import { render, staticRenderFns } from "./SCouponpack.vue?vue&type=template&id=71038c8d&scoped=true"
import script from "./SCouponpack.vue?vue&type=script&lang=js"
export * from "./SCouponpack.vue?vue&type=script&lang=js"
import style0 from "./SCouponpack.vue?vue&type=style&index=0&id=71038c8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71038c8d",
  null
  
)

export default component.exports